import { forwardRef } from "react";
import { Virtuoso, type VirtuosoHandle, type VirtuosoProps } from "react-virtuoso";
import { VirtuosoItem } from "./Item";
import { VirtuosoList } from "./List";
import { type IListVirtualizedContext, ListVirtualizedProvider } from "./context";

export interface IListVirtualizedProps<T, U>
  extends Omit<VirtuosoProps<T, U>, "data" | "itemContent">,
    IListVirtualizedContext {
  data: T[];
  itemContent: (index: number, value: T, context: U) => React.ReactElement | null;
}

export const ListVirtualized = forwardRef(function ListVirtualized<T, U>(
  { List, ListItem, ...props }: IListVirtualizedProps<T, U>,
  ref: React.Ref<VirtuosoHandle> | undefined
): React.ReactElement | null {
  return (
    <ListVirtualizedProvider List={List} ListItem={ListItem}>
      <Virtuoso ref={ref} {...props} components={{ ...props.components, List: VirtuosoList, Item: VirtuosoItem }} />
    </ListVirtualizedProvider>
  );
});
